import React from 'react';
import PropTypes from 'prop-types';
import { useChannelName, useMessageMode } from '../../../slice';
import './ChannelName.scss';
import logger from '../../../Helpers/logger';
import ChannelCategory from './ChannelCategory';

function ChannelName({
    channelId,
    className,
    channelName,
    asText = false,
    searchText = '',
    showAnnouncementIcon = true,
    channelStatus = '',
}) {
    let name = useChannelName(channelId);
    name = channelName || name;
    logger.debug('name channel name----', name, channelName, channelId);

    const messageMode = useMessageMode(channelId);

    const escapeRegExp = string => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    const getHighlightedName = () => {
        const trimmedText = searchText?.trim();
        if (!trimmedText) return name;

        const escapedSearchText = escapeRegExp(trimmedText);
        const regex = new RegExp(`(${escapedSearchText})`, 'ig');
        const parts = name.split(regex);

        return parts.map((part, idx) => {
            logger.debug('part0----', part);
            const key = `${part}-${idx}`;
            if (part.toLowerCase() === trimmedText.toLowerCase()) {
                return (
                    <span key={key} style={{ color: 'rgb(72, 121, 249)' }}>
                        {part}
                    </span>
                );
            }
            return <React.Fragment key={key}>{part}</React.Fragment>;
        });
    };

    if (asText) {
        return (
            <span className={className} title={name}>
                {getHighlightedName()}
            </span>
        );
    }

    return (
        <>
            {channelStatus !== 'channelInfo' && channelStatus !== 'explore' && (
                <div>
                    <p className={className} title={name}>
                        {getHighlightedName()}
                    </p>
                    {/* {messageMode === 2 && !channelName && showAnnouncementIcon && (
                  <img
                     src={ChannelAnnouncement}
                     style={{ width: '24px', height: '24px', marginLeft: '10px' }}
                     alt="Channels Icon"
                  />
               )} */}
                </div>
            )}
            {(channelStatus === 'channelInfo' || channelStatus === 'explore') && (
                <div>
                    <div>
                        <div className={className} title={name}>
                            {getHighlightedName()}
                        </div>
                        {/* {messageMode === 2 && !channelName && showAnnouncementIcon && (
                     <img
                        src={ChannelAnnouncement}
                        style={{ width: '24px', height: '24px', marginLeft: '10px' }}
                        alt="Channels Icon"
                     />
                  )} */}
                    </div>
                    <div>
                        <ChannelCategory channelId={channelId} channelStatus={channelStatus} />
                    </div>
                </div>
            )}
        </>
    );
}

const Memoized = React.memo(ChannelName);
export { Memoized as ChannelName };

ChannelName.propTypes = {
    channelId: PropTypes.string.isRequired,
    className: PropTypes.string,
    asText: PropTypes.bool,
    searchText: PropTypes.string,
    channelName: PropTypes.string,
    showAnnouncementIcon: PropTypes.bool,
};
